import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';

const cityContent = [
  {
    name: 'Chapecó',
    label: 'Capital do Oeste',
    image: '/region-chapeco.jpg',
    text: 'Polo econômico, universitário e de serviços, Chapecó combina estrutura urbana, aeroporto, acesso pelas principais rodovias regionais e uma forte cadeia agroindustrial. É uma cidade dinâmica para morar, trabalhar e investir.',
  },
  {
    name: 'Xanxerê',
    label: 'Força e conexão regional',
    image: '/region-xanxere.jpg',
    text: 'No coração do Alto Irani, Xanxerê se destaca pela posição estratégica, pelo agronegócio e por uma economia diversificada. A cidade oferece praticidade, bons serviços e bairros tranquilos para diferentes estilos de vida.',
  },
  {
    name: 'São Miguel do Oeste',
    label: 'Referência no Extremo Oeste',
    image: '/region-sao-miguel.jpg',
    text: 'Centro regional de comércio, saúde, educação e serviços, São Miguel do Oeste reúne oportunidades profissionais e a tranquilidade característica do interior, com uma vida urbana completa e acolhedora.',
  },
  {
    name: 'Maravilha',
    label: 'Qualidade de vida',
    image: '/region-maravilha.jpg',
    text: 'Conhecida pelo ambiente organizado e acolhedor, Maravilha une desenvolvimento, proximidade com a natureza e uma rotina mais tranquila. É uma ótima escolha para famílias e para quem deseja empreender.',
  },
  {
    name: 'Palmitos',
    label: 'Natureza e bem-estar',
    image: '/region-palmitos.jpg',
    text: 'Palmitos preserva a proximidade com o campo e oferece uma vida serena, sem abrir mão de serviços essenciais. Sua vocação agrícola e as paisagens verdes reforçam o potencial residencial e rural.',
  },
];

const benefits = [
  { icon: 'ri-line-chart-line', title: 'Economia forte', text: 'Agronegócio, indústria, comércio e serviços movimentam uma região empreendedora e em constante transformação.' },
  { icon: 'ri-heart-pulse-line', title: 'Qualidade de vida', text: 'Cidades acolhedoras, deslocamentos mais simples e boa oferta regional de saúde, educação e lazer.' },
  { icon: 'ri-road-map-line', title: 'Localização estratégica', text: 'Rodovias conectam os principais municípios e aproximam Santa Catarina dos mercados do Sul e do Mercosul.' },
  { icon: 'ri-home-heart-line', title: 'Boas oportunidades', text: 'Há opções para morar, investir, construir ou empreender, tanto nos centros urbanos quanto em áreas rurais.' },
];

export default function ConhecaARegiao() {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />

      <section className="relative min-h-[520px] overflow-hidden">
        <img src="/quem-somos-hero.png" alt="Paisagem urbana do Oeste Catarinense" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#061a35]/95 via-[#061a35]/70 to-[#061a35]/25" />
        <div className="relative mx-auto flex min-h-[520px] items-center px-6 py-20 md:px-8">
          <div className="max-w-2xl text-white">
            <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[.18em] backdrop-blur-sm"><i className="ri-map-pin-2-line text-primary-400" /> Conheça a região</span>
            <h1 className="mb-5 text-4xl font-extrabold leading-tight md:text-6xl">Oeste Catarinense:<br /><span className="text-primary-400">oportunidades para viver e investir.</span></h1>
            <p className="max-w-xl text-base leading-relaxed text-white/85 md:text-lg">Uma região que combina desenvolvimento econômico, cidades acolhedoras, natureza e a força de comunidades que sabem transformar trabalho em prosperidade.</p>
          </div>
        </div>
      </section>

      <section className="px-6 py-16 md:px-8 md:py-24">
        <div>
          <div className="mx-auto mb-12 max-w-3xl text-center">
            <span className="mb-3 block text-xs font-extrabold uppercase tracking-[.2em] text-primary-500">Por que escolher o Oeste?</span>
            <h2 className="mb-5 text-3xl font-extrabold text-secondary-950 md:text-4xl">Uma região completa para o seu próximo capítulo</h2>
            <p className="leading-7 text-slate-600">O Oeste Catarinense reúne a força produtiva do campo, indústrias reconhecidas, comércio ativo e centros urbanos que oferecem conforto sem perder a proximidade entre as pessoas.</p>
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {benefits.map((benefit) => (
              <article key={benefit.title} className="rounded-2xl border border-slate-200 bg-slate-50 p-7">
                <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-2xl text-white"><i className={benefit.icon} /></span>
                <h3 className="mb-3 text-lg font-extrabold text-secondary-950">{benefit.title}</h3>
                <p className="text-sm leading-7 text-slate-600">{benefit.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-50 px-6 py-16 md:px-8 md:py-24">
        <div>
          <div className="mb-12 max-w-2xl">
            <span className="mb-3 block text-xs font-extrabold uppercase tracking-[.2em] text-primary-500">Nossas cidades</span>
            <h2 className="text-3xl font-extrabold text-secondary-950 md:text-4xl">Cada cidade, um jeito especial de viver</h2>
          </div>
          <div className="space-y-8">
            {cityContent.map((city, index) => (
              <article key={city.name} className="grid overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm lg:grid-cols-2">
                <img src={city.image} alt={`Vista representativa de ${city.name}`} className={`h-72 w-full object-cover lg:h-full ${index % 2 ? 'lg:order-2' : ''}`} />
                <div className="flex flex-col justify-center p-8 md:p-12">
                  <span className="mb-3 text-xs font-extrabold uppercase tracking-[.18em] text-primary-500">{city.label}</span>
                  <h3 className="mb-4 text-3xl font-extrabold text-secondary-950">{city.name}</h3>
                  <p className="text-base leading-8 text-slate-600">{city.text}</p>
                  <a href={`/imoveis?cidade=${encodeURIComponent(city.name)}`} className="mt-6 inline-flex items-center gap-2 self-start text-sm font-bold text-primary-500 hover:text-primary-600">VER IMÓVEIS NA CIDADE <i className="ri-arrow-right-line" /></a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#061a35] px-6 py-14 text-white md:px-8">
        <div className="flex flex-col items-center justify-between gap-6 text-center md:flex-row md:text-left">
          <div><h2 className="mb-2 text-2xl font-extrabold md:text-3xl">Quer encontrar seu lugar no Oeste?</h2><p className="text-sm text-white/70">Conte o que você procura e nossa equipe apresenta as melhores oportunidades.</p></div>
          <a href="https://wa.me/554991950002" className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-7 py-4 text-sm font-bold text-white hover:bg-primary-600"><i className="ri-whatsapp-line text-xl" /> FALE CONOSCO</a>
        </div>
      </section>

      <Footer />
    </main>
  );
}
